export default __webpack_public_path__ + "static/media/aviary2.c3e2e277.png";